interface Comment {
  author: string;
  avatar: string;
  movie: string;
  rating: number;
  content: string;
  time: string;
}

const comments: Comment[] = [
  {
    author: '光影追梦人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20avatar%20with%20warm%20lighting%2C%20artistic%20cinema-themed%20profile%2C%20soft%20shadows%2C%20professional%20headshot%20style%2C%20neutral%20expression&width=80&height=80&seq=avatar-1-wuma&orientation=squarish',
    movie: '《流浪地球3》',
    rating: 5,
    content: '看完《流浪地球3》热泪盈眶！从第一部到第三部，中国科幻电影真的站起来了。画面、剧情、情感层层递进，尤其最后那段全人类携手的蒙太奇，直接封神。午马影院的高清画质让每一帧都震撼到骨子里，完全不输影院体验。',
    time: '2 小时前',
  },
  {
    author: '电影狂热者',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20portrait%20avatar%20with%20soft%20warm%20lighting%2C%20professional%20headshot%20style%2C%20friendly%20expression%2C%20clean%20background&width=80&height=80&seq=avatar-2-wuma&orientation=squarish',
    movie: '《封神第二部》',
    rating: 5,
    content: '等了两年终于等到第二部！特效比第一部又上了一个台阶，神仙斗法场面太炸了。姜子牙和哪吒那条线写得特别好，有笑有泪。午马影院秒播不缓冲，三个小时一口气看完，爽！',
    time: '5 小时前',
  },
  {
    author: '周末不加班',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20portrait%20avatar%20with%20warm%20lighting%2C%20casual%20style%2C%20professional%20headshot%2C%20relaxed%20expression%2C%20clean%20aesthetic&width=80&height=80&seq=avatar-3-wuma&orientation=squarish',
    movie: '《热辣滚烫》',
    rating: 5,
    content: '本来只是周末无聊点开看看，结果从头笑到尾又哭了好几次。太好看了！感觉说的就是我们这些普通人的故事。午马影院的片库真的全，想看的电影基本都能找到，已经成为我的日常追片首选了。',
    time: '1 天前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              观众热评
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              真实影迷的真实声音，看看大家都在聊哪些好电影
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {comments.map((comment, idx) => (
              <div
                key={idx}
                className="rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.author}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">{comment.author}</div>
                    <div className="text-xs text-foreground-500">{comment.time}</div>
                  </div>
                </div>
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                  ))}
                  <span className="text-xs text-foreground-500 ml-1.5">· {comment.movie}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {comment.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}